export function isEmptyValue(value: unknown): boolean {
  return (
    !value || value === false || (Array.isArray(value) && value.length === 0)
  );
}
